import React from "react";

const DashboardPage = () => {
  return <div></div>;
};

export default DashboardPage;
